export enum RequestStatus {
  PENDING_RETAILER = 'Pendente Comercializador',
  SOLVED = 'Resolvido',
  CANCELED = 'Anulado',
  SUBMITED = 'Submetido',
  IN_PROGRESS = 'Em curso E-REDES',
}
